export function calculatePeaksSync(audioBuffer, width = 8192) {
	const channels = audioBuffer.numberOfChannels;
	const audioBufferLength = audioBuffer.length;
	const samplesPerPeak = Math.max(1, Math.floor(audioBufferLength / width));
	const peaks = new Float32Array(width);

	for (let i = 0; i < width; i++) {
		const start = i * samplesPerPeak;
		let maxAbs = 0;
		const end = Math.min(audioBufferLength, start + samplesPerPeak);
		for (let ch = 0; ch < channels; ch++) {
			const data = audioBuffer.getChannelData(ch);
			for (let s = start; s < end; s++) {
				const v = Math.abs(data[s]);
				if (v > maxAbs) maxAbs = v;
			}
		}
		peaks[i] = maxAbs;
	}

	// normalizar por máximo global
	let globalMax = 0;
	for (let i = 0; i < peaks.length; i++) if (peaks[i] > globalMax) globalMax = peaks[i];
	if (globalMax > 0) {
		for (let i = 0; i < peaks.length; i++) peaks[i] = peaks[i] / globalMax;
	}

	return peaks;
}